import React, { ReactElement } from 'react'

interface Props {
  children?: React.ReactNode
  className?: string
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  style?: 'primary' | 'secondary'
}

const SmallText = ({
  children,
  className = '',
  onClick,
  style = 'primary'
}: Props): ReactElement => {
  return (
    <div
      onClick={onClick}
      className={`text-xs lg:text-sm ${className} ${
        style === 'secondary' ? 'text-grayText' : ''
      }`}
    >
      {children}
    </div>
  )
}

export default SmallText
